import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/daf893bep053ijub1ku0";

export default function NewsletterSection() {
  const [formStatus, setFormStatus] = useState<"idle" | "submitting" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (formStatus === "submitting") return;
    const form = e.currentTarget;
    const data = new FormData(form);

    // 反垃圾：蜜罐字段被填充则不真正提交
    const honeypot = String(data.get("website_alt") ?? "").trim();
    if (honeypot) {
      setFormStatus("success");
      return;
    }
    data.delete("website_alt");

    setFormStatus("submitting");
    setFormError("");
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const meta = (parsed?.meta ?? {}) as Record<string, unknown>;
      const code = String(parsed?.code ?? "");
      const serverMsg = String(meta?.message ?? meta?.detail ?? "");
      if (
        res.ok &&
        code === "OK" &&
        !serverMsg.toLowerCase().includes("spam")
      ) {
        setFormStatus("success");
        form.reset();
      } else {
        setFormStatus("error");
        setFormError(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setFormStatus("error");
      setFormError("网络开小差了，请稍后再试。");
    }
  };

  return (
    <section id="newsletter" className="scroll-mt-24 px-4 py-8 md:px-6">
      <div className="relative mx-auto max-w-6xl overflow-hidden rounded-3xl bg-accent-500 p-8 md:p-12">
        <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-background-50/10"></div>
        <div className="pointer-events-none absolute -bottom-14 -left-8 h-56 w-56 rounded-full bg-background-50/10"></div>

        <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/85 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-mail-send-fill"></i>
              每日梗报
            </span>
            <h2 className="mt-3 font-display text-3xl font-black text-background-50 md:text-4xl">
              订阅今日梗，每天三条笑点送到你邮箱
            </h2>
            <p className="mt-3 max-w-md text-sm leading-7 text-background-50/95 md:text-base">
              精选当天最高能的神回复与热梗，只发最精华的，绝不轰炸。退订随时可点，放心订阅。
            </p>
          </div>

          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="rounded-2xl bg-background-50 p-5 md:p-6"
            noValidate
          >
            {formStatus === "success" ? (
              <div className="flex flex-col items-center justify-center py-8 text-center">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-check-line text-2xl"></i>
                </span>
                <p className="mt-4 font-display text-lg font-bold text-foreground-900">订阅成功！</p>
                <p className="mt-1 text-sm text-foreground-600">今天的快乐，明天就送到你的邮箱。</p>
              </div>
            ) : (
              <>
                <p className="text-sm font-semibold text-foreground-900">填个邮箱，快乐不迷路</p>
                <div className="mt-4 flex flex-col gap-3 sm:flex-row">
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="you@example.com"
                    aria-label="电子邮箱"
                    className="w-full flex-1 rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-800 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                  />
                  <button
                    type="submit"
                    disabled={formStatus === "submitting"}
                    className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-all hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
                  >
                    {formStatus === "submitting" ? "提交中…" : "订阅今日梗"}
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="sg-aux"
                />
                {formError && (
                  <p className="mt-3 rounded-md bg-primary-50 px-3 py-2 text-xs text-primary-700" role="alert">
                    {formError}
                  </p>
                )}
                <p className="mt-3 text-xs leading-5 text-foreground-400">
                  提交即代表同意接收吃瓜快手每日精选内容。我们不会向任何第三方共享你的邮箱。
                </p>
              </>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}